import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../LanguageSwitcher';

const ClientNavbar = ({ agency, logout }) => {
    const { t, i18n } = useTranslation();

    return (
        <nav className="bg-hero-luxury border-b border-gold/10 shadow-lg px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center gap-4">
                        {agency?.logo && (
                            <img src={`${import.meta.env.VITE_API_URL || ''}/static/agency_logos/${agency.logo}`} alt={i18n.language === 'ar' ? (agency.name_ar || agency.name) : (agency.name_en || agency.name)} className="h-10 w-10 object-contain" />
                        )}
                        <h1 className="text-xl font-bold text-text-invert">{i18n.language === 'ar' ? (agency?.name_ar || agency?.name || t('myTours')) : (agency?.name_en || agency?.name || t('myTours'))}</h1>
                    </div>
                    <div className="flex items-center gap-2 sm:gap-3">
                        <a
                            href={`/agency/${agency?.slug}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="p-2 sm:px-4 sm:py-2 text-sm font-medium text-gold bg-bg-soft hover:bg-gold hover:text-primary border border-gold/20 rounded-lg transition-all duration-300 flex items-center gap-2"
                            title={t('viewPublicPage')}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                            <span className="hidden sm:inline">{t('viewPublicPage') || 'View Public Page'}</span>
                        </a>
                        <LanguageSwitcher />
                        <button
                            onClick={logout}
                            className="p-2 sm:px-4 sm:py-2 text-sm font-medium text-textMuted bg-bg-soft hover:bg-danger-900/30 hover:text-danger-400 border border-gold/10 hover:border-danger-500/30 rounded-lg transition-all duration-300 flex items-center gap-2"
                            title={t('logout')}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                            </svg>
                            <span className="hidden sm:inline">{t('logout')}</span>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default ClientNavbar;
